import { RoundButton } from '../button';
import Icon from '../icon';
import DotsLoader from '../dots-loader';
import Input, { DEFAULT_INPUT_SIZE, InputProps } from './input';
import InputContainer from './input-container';
import { sizes } from './style';

interface SearchInputProps extends InputProps {
  onClear?: () => void;
  loading?: boolean;
  disableClear?: boolean;
  icons?: Array<'left' | 'right'>;
}

const defaultIcons: SearchInputProps['icons'] = ['left', 'right'];

const SearchInput = ({
  value,
  onChange,
  onBlur,
  onFocus,
  disabled,
  readOnly,
  onClear,
  variant,
  size,
  loading,
  disableClear,
  icons = defaultIcons,
  ...rest
}: SearchInputProps) => {
  const isClearButtonAvailable = !disableClear && onClear;

  return (
    <InputContainer size={size} icons={icons}>
      {icons.includes('left') && (
        <InputContainer.LeftIconContainer>
          <InputContainer.Icon size={sizes[size || DEFAULT_INPUT_SIZE]?.iconSize} name={'SEARCH'} />
        </InputContainer.LeftIconContainer>
      )}
      <Input
        value={value}
        onChange={onChange}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        variant={variant}
        size={size}
        readOnly={readOnly}
        {...rest}
      />
      {loading ? (
        <InputContainer.RightIconContainer>
          <DotsLoader size={'xxs'} variant={'gray400'} />
        </InputContainer.RightIconContainer>
      ) : (
        value &&
        !disabled &&
        !readOnly &&
        isClearButtonAvailable && (
          <InputContainer.RightButtonContainer>
            <RoundButton
              onClick={onClear}
              data-name={'clear-search'}
              variant={'secondary-clean'}
              aria-label={'Clear search'}
              size={'xs'}
            >
              <Icon name={'CLOSE'} variant={'inherit'} size={'md'} />
            </RoundButton>
          </InputContainer.RightButtonContainer>
        )
      )}
    </InputContainer>
  );
};

SearchInput.displayName = 'SearchInput';
export default SearchInput;
